import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const EducationIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.73795 1.8047C7.89865 1.70581 8.10135 1.70581 8.26205 1.8047L14.762 5.8047C14.9099 5.8957 15 6.0569 15 6.23053C15 6.25475 14.9982 6.27872 14.9948 6.30229C14.9982 6.33132 15 6.36086 15 6.39081V9.98053C15 10.3947 14.6642 10.7305 14.25 10.7305C13.8358 10.7305 13.5 10.3947 13.5 9.98053V7.433L8.26205 10.6564C8.10135 10.7552 7.89865 10.7552 7.73795 10.6564L1.23795 6.65636C1.09008 6.56536 1 6.40416 1 6.23053C1 6.0569 1.09008 5.8957 1.23795 5.8047L7.73795 1.8047ZM4.21126 9.78296C4.34132 9.70585 4.49914 9.7143 4.62188 9.80494L7.5 11.7305C7.63436 11.8297 8.36564 11.8297 8.5 11.7305L11.3781 9.80494C11.5009 9.7143 11.6587 9.70585 11.7887 9.78296C11.9188 9.86006 12 10.0102 12 10.1736V12.6104C12 12.6679 11.9899 12.7249 11.9702 12.7782C10.5164 16.7146 5.48364 16.7146 4.02978 12.7782C4.01012 12.7249 4 12.6679 4 12.6104V10.1736C4 10.0102 4.08119 9.86006 4.21126 9.78296Z"
		/>
	</svg>
))
